/**
 * Whether this browser was signed in when the dashboard last checked. Only
 * index.html reads it, to choose the first paint: the sign-in gate for someone
 * signed out, the camp's loader (AuthGate) for someone probably signed in.
 * `auth.me` decides either way: the session cookies are HttpOnly, so no marker
 * a page can read proves anyone signed in or out (hooks/useAuth.ts). index.html
 * spells the key out; GateShell.test.tsx keeps the two in step.
 */
export const SESSION_HINT_KEY = 'badland-signed-in'

export function writeSessionHint(signedIn: boolean): void {
  try {
    if (signedIn) localStorage.setItem(SESSION_HINT_KEY, '1')
    else localStorage.removeItem(SESSION_HINT_KEY)
  } catch {
    // Storage can be off or full. A wrong guess costs one first paint, nothing more.
  }
}
